<template>
  <div class="wrap">
    <adminSidemenu :parent.sync="parent" />
    <div class="header-individual short">
      <div class="pointer" style="font-size: 20px; color: #333; font-weight:700">管理者画面</div>
      <!-- <el-badge v-if="notification.slave" :value="1" :type="notification.slave.io=='Yes'&&notification.slave.sql=='Yes' ? 'success' : 'danger'" class="item">
        <el-button size="mini" style="margin-left: 30px;" @click="(parent = 'Admin'), (adminActive = 'slave'), slaveStatus('slave')">Slave</el-button>
      </el-badge> -->
      <el-badge
        v-if="notification.message_sending"
        :hidden="notification.message_sending.length == 0 ? true : false"
        :value="notification.message_sending ? notification.message_sending.length : '-'"
        :max="10"
        class="item"
        type="success"
      >
        <el-button size="mini" style="margin-left: 30px;" @click="(parent = 'Client'), (clientActive = 'message')">送信中DM</el-button>
      </el-badge>
      <el-badge
        v-if="notification.message_error"
        :hidden="notification.message_error.length == 0 ? true : false"
        :value="notification.message_error ? notification.message_error.length : '-'"
        :max="5"
        class="item"
      >
        <el-button size="mini" style="margin-left: 20px;" @click="(parent = 'Client'), (clientActive = 'message')">Message Error</el-button>
      </el-badge>
      <el-badge v-if="notification.invoice_unsent" :hidden="!notification.invoice_unsent" :value="notification.invoice_unsent" :max="5" class="item">
        <el-button size="mini" style="margin-left: 30px;" @click="(parent = 'Client'), (clientActive = 'payment')">未発行請求書</el-button>
      </el-badge>
      <el-badge v-if="notification.request" :hidden="notification.request.length == 0 ? true : false" :value="notification.request ? notification.request.length : '-'" :max="20" class="item">
        <el-button size="mini" style="margin-left: 30px;" @click="(parent = 'Client'), (clientActive = 'request')">未対応リクエスト</el-button>
      </el-badge>
    </div>

    <!-- ユーザーページ -->
    <div class="list-detail-page-wrap">
      <div v-if="parent == 'Dashboard'">
        <adminDashboard />
      </div>

      <div v-if="parent == 'Client'">
        <el-tabs v-model="clientActive" class="tab-admin">
          <el-tab-pane label="クライアント" name="client">
            <adminList v-if="clientActive == 'client'" :notification.sync="notification" :type="'client'" />
          </el-tab-pane>

          <el-tab-pane label="メンバー" name="member">
            <adminList v-if="clientActive == 'member'" :notification.sync="notification" :type="'member'" />
          </el-tab-pane>

          <el-tab-pane label="アクティビティ" name="client_activity">
            <adminList v-if="clientActive == 'client_activity'" :notification.sync="notification" :type="'client_activity'" />
          </el-tab-pane>

          <el-tab-pane label="ログ" name="client_log">
            <adminList v-if="clientActive == 'client_log'" :notification.sync="notification" :type="'client_log'" />
          </el-tab-pane>

          <el-tab-pane label="検索ログ" name="search_history">
            <adminList v-if="clientActive == 'search_history'" :notification.sync="notification" :type="'search_history'" />
          </el-tab-pane>

          <el-tab-pane label="NPS" name="client_nps">
            <adminList v-if="clientActive == 'client_nps'" :notification.sync="notification" :type="'client_nps'" />
          </el-tab-pane>

          <el-tab-pane label="IG" name="ig">
            <adminList v-if="clientActive == 'ig'" :notification.sync="notification" :type="'ig'" />
          </el-tab-pane>

          <el-tab-pane label="リスト" name="list">
            <adminList v-if="clientActive == 'list'" :notification.sync="notification" :type="'list'" />
          </el-tab-pane>

          <el-tab-pane label="リストIF" name="list_influencer">
            <adminList v-if="clientActive == 'list_influencer'" :notification.sync="notification" :type="'list_influencer'" />
          </el-tab-pane>

          <el-tab-pane label="レポート" name="report">
            <adminList v-if="clientActive == 'report'" :notification.sync="notification" :type="'report'" />
          </el-tab-pane>

          <el-tab-pane label="レポートIF" name="report_influencer">
            <adminList v-if="clientActive == 'report_influencer'" :notification.sync="notification" :type="'report_influencer'" />
          </el-tab-pane>

          <el-tab-pane label="メッセージ" name="message">
            <adminList v-if="clientActive == 'message'" :notification.sync="notification" :type="'message'" />
          </el-tab-pane>

          <el-tab-pane label="メッセージ受信者" name="message_recipient">
            <adminList v-if="clientActive == 'message_recipient'" :notification.sync="notification" :type="'message_recipient'" />
          </el-tab-pane>

          <el-tab-pane label="メッセージテンプレ" name="phrase">
            <adminList v-if="clientActive == 'phrase'" :notification.sync="notification" :type="'phrase'" />
          </el-tab-pane>

          <el-tab-pane label="請求書" name="payment">
            <adminList v-if="clientActive == 'payment'" :notification.sync="notification" :type="'payment'" />
          </el-tab-pane>

          <el-tab-pane label="契約/解約履歴" name="upgrade_log">
            <adminList v-if="clientActive == 'upgrade_log'" :notification.sync="notification" :type="'upgrade_log'" />
          </el-tab-pane>

          <el-tab-pane label="リクエスト" name="request">
            <adminList v-if="clientActive == 'request'" :notification.sync="notification" :type="'request'" />
          </el-tab-pane>

          <el-tab-pane label="リクエストIF" name="request_i">
            <adminList v-if="clientActive == 'request_i'" :notification.sync="notification" :type="'request_i'" />
          </el-tab-pane>

          <el-tab-pane label="重複許可ドメイン" name="deplicate_allow_domains">
            <adminList v-if="clientActive == 'deplicate_allow_domains'" :notification.sync="notification" :type="'deplicate_allow_domains'" />
          </el-tab-pane>

          <el-tab-pane label="OEM管理" name="oem_list">
            <adminList v-if="clientActive == 'oem_list'" :notification.sync="notification" :type="'oem_list'" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <div v-if="parent == 'Influencer'">
        <el-tabs v-model="influencerActive" class="tab-report">
          <el-tab-pane label="Instagram" name="influencer">
            <adminList v-if="influencerActive == 'influencer'" :notification.sync="notification" :type="'influencer'" />
          </el-tab-pane>

          <el-tab-pane label="YouTube" name="youtuber_list">
            <adminList v-if="influencerActive == 'youtuber_list'" :notification.sync="notification" :type="'youtuber_list'" />
          </el-tab-pane>

          <el-tab-pane label="Tiktok" name="tiktoker_list">
            <adminList v-if="influencerActive == 'tiktoker_list'" :notification.sync="notification" :type="'tiktoker_list'" />
          </el-tab-pane>

          <el-tab-pane label="オーディエンス" name="influencer_audience">
            <adminList v-if="influencerActive == 'influencer_audience'" :notification.sync="notification" :type="'influencer_audience'" />
          </el-tab-pane>

          <el-tab-pane label="オーディエンス平均" name="influencer_audience_calc">
            <adminList v-if="influencerActive == 'influencer_audience_calc'" :notification.sync="notification" :type="'influencer_audience_calc'" />
          </el-tab-pane>
          <el-tab-pane label="Modashデータ登録" name="modash_data_registry">
            <modashDataRegistry v-if="influencerActive == 'modash_data_registry'" :notification.sync="notification" :type="'modash_data_registry'" />
          </el-tab-pane>
        </el-tabs>
      </div>

      <div v-if="parent == 'Admin'">
        <el-tabs
          v-model="adminActive"
          @tab-click="adminActive == 'slave' ? slaveStatus('slave') : adminActive == 'process' ? slaveStatus('process') : adminActive == 'ig_session' ? igSessionStatus() : ''"
          class="tab-report"
        >
          <el-tab-pane label="通知" name="notify">
            <adminList v-if="adminActive == 'notify'" :notification.sync="notification" :type="'notify'" />
          </el-tab-pane>

          <el-tab-pane label="アプリバージョン" name="app">
            <adminList v-if="adminActive == 'app'" :notification.sync="notification" :type="'app'" />
          </el-tab-pane>

          <el-tab-pane label="ターゲットリスト" name="target">
            <adminList v-if="adminActive == 'target'" :notification.sync="notification" :type="'target'" />
          </el-tab-pane>

          <el-tab-pane label="メンテナンス" name="maintenance">
            <adminList v-if="adminActive == 'maintenance'" :notification.sync="notification" :type="'maintenance'" />
          </el-tab-pane>

          <el-tab-pane label="プロモコード" name="promoCode">
            <adminList v-if="adminActive == 'promoCode'" :notification.sync="notification" :type="'promocode'" />
          </el-tab-pane>

          <el-tab-pane label="プロモコード作成" name="createPromoCode">
            <promoCode v-if="adminActive == 'createPromoCode'" />
          </el-tab-pane>

          <!-- <el-tab-pane label="スレーブ" name="slave">
            <div style="padding:20px; background-color:#fff; border-radius:10px; color:#666">
              <div class="flex-row" v-for="(slave, index) in slave_status" :key="index" style="height: 24px; border-bottom:1px solid #eee;">
                <div style="width:200px">{{ index }}:</div>
                <div class="flex-row">
                  <div v-if="index == 'Slave_IO_Running' || index == 'Slave_SQL_Running'" class="status-button" :class="slave == 'Yes' ? 'success' : 'danger'" style="margin-right: 5px;"></div>
                  {{ slave }}
                </div>
              </div>
            </div>
          </el-tab-pane> -->

          <!-- <el-tab-pane label="プロセス" name="process">
            <div style="padding:20px; background-color:#fff; border-radius:10px; color:#666">
              <div class="flex-row" v-for="(process, index) in process_list" :key="index" style="height: 24px; border-bottom:1px solid #eee;">
                <div style="width:200px">{{ index }}:</div>
                <div class="flex-row">
                  {{process}}
                </div>
              </div>
            </div>
          </el-tab-pane> -->

          <!-- <el-tab-pane label="IGセッション" name="ig_session">
            <div style="padding:20px; background-color:#fff; border-radius:10px; color:#666">
              <div style="display:flex; flex-flow:row; margin-bottom:10px">
                <div class="status-button" :class="session_info.session_is_effective ? 'success' : 'danger'" style="margin-right: 10px;"></div>
                <div class="flex-row">
                  IG_Session_Effective:
                  <div class="loader--mini" v-if="session_loading"></div>
                  <span v-else> {{ session_info.session_is_effective ? "Yes" : "No" }} </span>
                </div>
              </div>
            </div>
          </el-tab-pane> -->

          <el-tab-pane label="請求書" name="invoice">
            <adminList v-if="adminActive == 'invoice'" :notification.sync="notification" :type="'invoice'" />
          </el-tab-pane>

          <el-tab-pane label="請求書(月次)" name="invoice_monthly">
            <adminList v-if="adminActive == 'invoice_monthly'" :notification.sync="notification" :type="'invoice_monthly'" />
          </el-tab-pane>
          
          <el-tab-pane label="プラン管理" name="service_plans">
            <adminList v-if="adminActive == 'service_plans'" :notification.sync="notification" :type="'service_plans'" />
          </el-tab-pane>

          <el-tab-pane label="Bright Data GIP" name="bright_data_gips">
            <adminList
                v-if="adminActive == 'bright_data_gips'"
                :notification.sync="notification"
                :type="'bright_data_gips'"
            />
          </el-tab-pane>
          <el-tab-pane label="Instagram_更新頻度設定" name="instagram_scraping_settings">
            <scrapingSetting
                v-if="adminActive == 'instagram_scraping_settings'"
                :notification.sync="notification"
                :type="'instagram_scraping_settings'"
                :sns_type="'instagram'"
            />
          </el-tab-pane>
          <el-tab-pane label="TikTok_更新頻度設定" name="tiktok_scraping_settings">
            <scrapingSetting
                v-if="adminActive == 'tiktok_scraping_settings'"
                :notification.sync="notification"
                :type="'tiktok_scraping_settings'"
                :sns_type="'tiktok'"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>

const root = process.env.VUE_APP_API;
const statusAPI = root + "/api/admin/status";
const igSessionStatusAPI = root + "/api/admin/status_session";
import adminList from "./adminList";
import adminSidemenu from "./adminSidemenu";
import adminDashboard from "./adminDashboard";
import promoCode from "./promoCode";
import modashDataRegistry from "./modashDataRegistry";
import scrapingSetting from "./scrapingSetting";

export default {
  name: "admin",
  components: {
    adminList,
    adminSidemenu,
    adminDashboard,
    promoCode,
    modashDataRegistry,
    scrapingSetting
  },
  props: ["name"],
  data() {
    return {
      parent: "Client",
      clientActive: "client",
      influencerActive: "influencer",
      adminActive: "notify",
      slave: [],
      slave_status: {},
      session_info: [],
      session_loading: false,
      process_list: [],
      notification: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.adminModeOn();
  },
  methods: {
    adminModeOn() {
      this.$store.dispatch("adminModeOn");
      this.$store.dispatch("changeActive", "");
    },
    slaveStatus(type) {
      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("type", type);
      this.axios
        .post(statusAPI, params)
        .then((response) => {
          if (type == "slave") {
            this.slave = response.data.slave;
            this.slave_status = response.data.slave_status;
          } else if (type == "process") {
            this.process_list = response.data.process_list;
          }
        })
        .catch(() => {});
    },
    igSessionStatus() {
      this.session_loading = true;
      var params = new URLSearchParams();
      params.append("token", this.token);
      this.axios
        .post(igSessionStatusAPI, params)
        .then((response) => {
          this.session_info = response.data.session_info;
          this.session_loading = false;
        })
        .catch(() => {
          this.session_loading = false;
        });
    },
  },
  watch: {},
};
</script>

<style></style>
